const ATTENDANCE_BADGES = {
  attended: { color: "success", label: "Attended" },
  no_show: { color: "error", label: "No-show" },
};

const NOT_YET_BADGE = { color: "gray", label: "Not yet" };

export const NOT_YET = "not_yet";

export const attendanceBadge = (status) => ATTENDANCE_BADGES[status] || NOT_YET_BADGE;
